import { DateTime } from 'luxon';

const getFullDate = (date: string | null | undefined) => {
  if (!date) { return 'Invalid Date'; }
  const convertedDate: DateTime = DateTime.fromISO(date);
  return convertedDate.toFormat('MM/dd/yyyy');
};
export default getFullDate;
